import { render, staticRenderFns } from "./Tab7.vue?vue&type=template&id=04902b09&scoped=true"
import script from "./Tab7.vue?vue&type=script&lang=js"
export * from "./Tab7.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/pei/parte-k.css?vue&type=style&index=0&id=04902b09&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04902b09",
  null
  
)

export default component.exports